import { logEvent } from 'commons/utils/tracking';
import {
  NUVEMCHAT_INFO_CLICK,
  NUVEMCHAT_INSTALL_CLICK,
  NUVEMCHAT_WAITLIST_CLICK,
} from 'config/trackingEvents';

export const trackingNuvemChatInstallClick = () => {
  logEvent(NUVEMCHAT_INSTALL_CLICK, {});
};
export const trackingNuvemChatWaitListClick = (email: string) => {
  logEvent(NUVEMCHAT_WAITLIST_CLICK, { email });
};
export const trackingNuvemChatInfoClick = () => {
  logEvent(NUVEMCHAT_INFO_CLICK, {});
};
